module.exports = __webpack_public_path__ + "static/media/varal-muro.d741bb00.png";